import React from 'react';
import FeedContainerBig from './FeedContainerBig.jsx';


const BigNewsFirstItem = ({ article, showExtraBanner }) =>
    <div className="row featured-big-template">
        <div className="template-item featured-big">
            <div className="content">

                <FeedContainerBig contentContainer={article}
                    showExtraBanner={showExtraBanner}
                    />
            </div>
        </div>
    </div>;

export default BigNewsFirstItem;



// WEBPACK FOOTER //
// ./src/component/NewsFeed/BigNewsFirstItem.jsx